// src/features/tidsregistering/hooks/useUnavailability.js
import { useState, useCallback } from 'react';
import { unavailabilityAPI } from '../services/unavailability';
import { useApi } from '../../../hooks/api/useApi';

export function useUnavailability() {
  const [blocks, setBlocks] = useState([]);
  const [availabilityCheck, setAvailabilityCheck] = useState(null);
  const { loading, error, execute, clearError } = useApi();

  const fetchDepartmentUnavailability = useCallback(async (startDate, endDate) => {
    const result = await execute(() => unavailabilityAPI.getDepartmentUnavailability(startDate, endDate));
    if (result.success) setBlocks(result.data?.blocks ?? []);
    else setBlocks([]);
    return result;
  }, [execute]);

  const checkAvailability = useCallback(async (staffMemberId, startDate, endDate, startTime = null, endTime = null) => {
    const result = await execute(() =>
      unavailabilityAPI.checkStaffAvailability(staffMemberId, startDate, endDate, startTime, endTime),
    );
    if (result.success) setAvailabilityCheck(result.data ?? null);
    else setAvailabilityCheck(null);
    return result;
  }, [execute]);

  const clear = useCallback(() => {
    setBlocks([]);
    setAvailabilityCheck(null);
  }, []);

  return {
    blocks,
    availabilityCheck,
    loading,
    error,
    clearError,
    fetchDepartmentUnavailability,
    checkAvailability,
    clear,
  };
}
